import {
  External_Loyalty_Manual_Offer_Activate_Status,
  External_Loyalty_Manual_Offer_Status,
  OffersFilterValues,
} from './tobacco-api-offers.types';

export const ROWS_PER_PAGE = 20;

export const TOBACCO_OFFERS_LIST_POLL_INTERVAL_MS = 7000;
export const TOBACCO_OFFERS_LIST_POLL_TIMEOUT_MS = 120_000;

export const PAGE_TITLE = 'Tobacco API Offers';
export const PAGE_SUBTITLE =
  'Automatically update Tobacco Offers from the Altria and RJR APIs';

export const ACTIVE_TABLE_TITLE = 'Active Offers: Enable or Disable Offers';
export const INACTIVE_TABLE_TITLE = 'In-Active Offers: Enable Currently Valid Offers';
export const UPCOMING_TABLE_TITLE = 'Upcoming Offers: Enable or Disable Offers';

export const EXTERNAL_LOYALTY_OFFER_STATUSES = Object.values(External_Loyalty_Manual_Offer_Status);

export const STATUS_COLOR: Record<External_Loyalty_Manual_Offer_Status, string> = {
  [External_Loyalty_Manual_Offer_Status.Created]: 'success.main',
  [External_Loyalty_Manual_Offer_Status.Errored]: 'error.main',
  [External_Loyalty_Manual_Offer_Status.ManualUpdated]: 'info.main',
  [External_Loyalty_Manual_Offer_Status.Outdated]: 'warning.main',
  [External_Loyalty_Manual_Offer_Status.PendingToCreate]: 'warning.main',
  [External_Loyalty_Manual_Offer_Status.Ready]: 'info.main',
};

export const STATUS_LABEL: Record<External_Loyalty_Manual_Offer_Status, string> = {
  [External_Loyalty_Manual_Offer_Status.Created]: 'Created',
  [External_Loyalty_Manual_Offer_Status.Errored]: 'Errored',
  [External_Loyalty_Manual_Offer_Status.ManualUpdated]: 'Manual Updated',
  [External_Loyalty_Manual_Offer_Status.Outdated]: 'Outdated',
  [External_Loyalty_Manual_Offer_Status.PendingToCreate]: 'Pending to Create',
  [External_Loyalty_Manual_Offer_Status.Ready]: 'Ready',
};

export const ACTIVATE_STATUS_COLOR: Record<External_Loyalty_Manual_Offer_Activate_Status, string> = {
  [External_Loyalty_Manual_Offer_Activate_Status.Published]: 'success.main',
  [External_Loyalty_Manual_Offer_Activate_Status.Unpublished]: 'error.main',
};

export const ACTIVATE_STATUS_LABEL: Record<External_Loyalty_Manual_Offer_Activate_Status, string> = {
  [External_Loyalty_Manual_Offer_Activate_Status.Published]: 'Published',
  [External_Loyalty_Manual_Offer_Activate_Status.Unpublished]: 'Unpublished',
};

export const DEFAULT_FILTER_VALUES: OffersFilterValues = {
  brand: '',
  manufacturer: '',
  states: [],
  runDatesStart: '',
  runDatesEnd: '',
  isErrored: 'all',
  status: '',
  name: '',
  externalCampaignId: '',
  retailerNetworkUuid: '',
  retailerNetworkName: '',
};

